import { Modal } from "react-bootstrap";
import React, { useState } from "react";
const API_IMG = "https://image.tmdb.org/t/p/w500/";

const MovieBox = ({
  title,
  poster_path,
  vote_average,
  release_date,
  overview,
  vote_count,
  original_language,
}) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    // <div className="text-center bg-secondary mb-3">
    <div className="flex flex-col relative  px-5 text-white mb-10">
      <div className="flex flex-col relative">
        <h4 className="absolute  bg-[#5651e5] px-3 rounded-[5px]">
          {vote_average}
        </h4>
        <img
          className="object-cover w-full h-full rounded-[5px]"
          src={API_IMG + poster_path}
          alt=""
        />
        <div className="absolute bottom-1 mx-2 flex text-white ">
          <button
            type="button"
            className=" rounded-md px-3 py-1 my-4 sm:px-2 bg-gradient-to-r from-[var(--primary-dark)] to-[var(--primary-light)]  sm:text-[13px]"
            onClick={handleShow}
          >
            View More
          </button>
        </div>
      </div>
      <h3 className="flex text-[15px] dark:text-black text-white font-[Roboto] ">
        {title}
      </h3>

      {/* Modal */}
      <div className="mx-5 ml-[50px] ">
        <Modal
          show={show}
          onHide={handleClose}
          className="mx-[50px] border-2 p-4 h-full my-10"
        >
          {/* <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header> */}
          <Modal.Body className="grid lg:grid-cols-2 sm:grid-cols-1 text-left  mx-auto">
            <div className="flex flex-col">
              <img
                className=""
                style={{ width: "14rem" }}
                src={API_IMG + poster_path}
                alt=""
              />
              <p className="dark:text-black text-white">
                Language: {original_language}
              </p>
              <p className="dark:text-gray-400 text-gray-500">
                Votes: {vote_count}
              </p>
            </div>

            <div className="dark:text-black text-white py-6 mx-5">
              <h3>{title}</h3>
              <h5>Release Date: {release_date}</h5>
              <br></br>
              <h6>Description:</h6>
              <p>{overview}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="mx-auto">
              <button
                variant="secondary"
                className="dark:text-black text-white py-2  my-2 bg-gradient-to-r from-[var(--primary-dark)] to-[var(--primary-light)] mx-auto"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default MovieBox;
